import type { User } from 'shared/api/users';
import { isOrgAdmin } from 'shared/helpers';
import { TAG_BASED_ACCESS_TYPES, AccessType } from '../components/enums';

export const areAccessTagsRequiredForLayer = (
  accessType: AccessType | null | undefined,
  loggedUser: User | undefined | null,
): boolean =>
  !!accessType &&
  TAG_BASED_ACCESS_TYPES.has(accessType) &&
  !isOrgAdmin(loggedUser);

export const areAccessTagsRequiredForIteration = (
  accessType: AccessType | null | undefined,
  loggedUser: User | undefined | null,
): boolean =>
  accessType === AccessType.RestrictedSiteData && !isOrgAdmin(loggedUser);
